<template>
  <div id="app">
    <md-tabs class="md-primary" md-sync-route v-if="isLoggedIn">
      <md-tab id="tab-home" md-label="Home" to="home" md-icon="home"></md-tab>
      <md-tab v-if="isAdmin" md-label="Users" id="tab-users" md-icon="people" to="users"></md-tab>
      <md-tab id="tab-dashboard" to="dashboard" md-label="Dashboard" md-icon="dashboard"></md-tab>
      <md-tab id="tab-logout"
              md-label="Logout"
              @click="logout"
              md-icon="power_settings_new">
        Logout
      </md-tab>
    </md-tabs>
    <router-view/>
  </div>
</template>

<script>
export default {
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  created() {
    this.$http.interceptors.response.use(
      undefined,
      err => new Promise(() => {
        /* eslint no-underscore-dangle: 0 */
        if (
          err.response.status === 401
            && err.config
            && !err.config.__isRetryRequest
        ) {
          this.$store.dispatch('logout');
        }
        throw err;
      }),
    );

    this.$store.dispatch('verify').catch(() => {
      this.$router.push('/login');
    });

    setInterval(() => {
      if (this.isLoggedIn) {
        this.$store.dispatch('verify').catch(() => {
          this.$router.push('/login');
        });
      }
    }, 1000 * 60 * 5); // refresh token every 5 minutes
  },
  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    },
  },
};
</script>


<style lang="scss">
@import "scss/main";

body, .md-tab {
  background-color: #F6F5F1;
}

#nav {
  background-color: #53ACCC;
  color: #fff;
  padding: 1rem;

  a {
    font-weight: 700;
    color: #fff;

    &.router-link-exact-active {
      text-decoration: underline;
    }
  }
}
</style>
